import { get } from '../../common/axiosClient';
import { API } from '../../common/constants/urls';
import { City, County, CustomArea, State } from './lookups.type';

export const getStates = async () => {
  return (await get(`${API.ADDRESS}/states`)) as State[];
};

export const getCounties = async () => {
  return (await get(`${API.ADDRESS}/counties`)) as County[];
};

export const getCustomAreas = async () => {
  return (await get(`${API.ADDRESS}/custom-areas`)) as CustomArea[];
};

export const getCities = async () => {
  return (await get(`${API.ADDRESS}/cities`)) as City[];
};

export interface ValidateCityStateResult {
  isValid: boolean;
  standardizedCity?: string | null;
  standardizedStateCode?: string | null;
}

// Google Geocode fallback for a city/state pair missing from our Cities lookup table.
export const validateCityState = async (city: string, state: string) => {
  return (await get(`${API.ADDRESS}/validate-city-state`, { params: { city, state } })) as ValidateCityStateResult;
};
